"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class MerchantApi {
    constructor(api) {
        this.api = api;
    }
    getMerchant(merchantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/merchant/${merchantId}`;
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    getMerchantNotices(merchantId, deliveryType, latlng, utcTimeString, categoryTag) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/merchant/${merchantId}/noticeCards`;
            const response = yield this.api.axiosNode.get(endpoint, {
                params: {
                    deliveryType,
                    lat: latlng === null || latlng === void 0 ? void 0 : latlng.lat,
                    lng: latlng === null || latlng === void 0 ? void 0 : latlng.lng,
                    time: utcTimeString,
                    categoryTag: categoryTag, // 盆菜活動因運費固定所以不顯示運費警告
                },
            });
            return response.data;
        });
    }
    getTimeslot(merchantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/merchant/${merchantId}/timeslots`;
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    link() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/merchant/link';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    getUiVersion(client) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/s/health/version', { client: client });
            return response.data;
        });
    }
}
exports.default = MerchantApi;
//# sourceMappingURL=Merchant.js.map